<template>
  <div class="rodemap" :class="{ r1: index === 1 }">
    <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';

//Global
import Global from '../../../scripts/Global';
import WordDialog from '../../cmp/wordDialog';

export default {
  data() {
    return {
      index: 0,
      arr: [
        {
          headImg: 'cv-04',
          word:
            '琼苑东门和琼苑西门连接的是宫斗剧里经常出现的三宫六院，穿过琼苑西门还可以走上西一长街。街西从北至南有大成右门、咸和右门、遵义门。',
          audio: 'ytx',
          scene: 'scene1',
        },
        {
          headImg: 'cv-04',
          word:
            '从琼苑西门一直往南过了遵义门便可通往养心殿。养心殿内曾有宫中造办处的作坊，后来用作清朝皇帝居住的寝宫。',
          audio: 'ytx',
          scene: 'scene1_1',
        },
      ],
    };
  },
  components: {
    WordDialog,
  },
  created() {},
  computed: {},
  methods: {
    jump(event) {
      this.index += 1;
      if (this.arr.length === this.index) {
        this.$router.replace('/rodemap/ytx/02');
        this.index--;
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/琼苑西门.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}

.r1 {
  background-image: url(//cdn.original-fun.com/gugong/琼苑西门.jpg);
}
</style>
